import { type OpenApiSchemaProductVariant, type OpenApiSchemaProductVariantListItem } from '#shared/api/schema';

export function getUpdatedPriceIndexSummary(
    currentVariant: OpenApiSchemaProductVariantListItem,
    updatedVariant: OpenApiSchemaProductVariant
): OpenApiSchemaProductVariantListItem['price_index_summary'] {
    const currentSummary = currentVariant.price_index_summary;
    const updatedSignal = updatedVariant.price_index?.signal;

    if (!updatedSignal) {
        return currentSummary;
    }

    return {
        ...currentSummary,
        signal: updatedSignal,
    };
}
